export function workspaceImageUrlFromStorageKey(storageKey: string) {
	const params = new URLSearchParams({ key: storageKey });
	return `/api/workspaces/image?${params.toString()}`;
}

export function normalizeWorkspaceImageUrl(imageUrl?: string | null) {
	if (!imageUrl) return null;
	if (imageUrl.startsWith("/api/workspaces/image?")) return imageUrl;

	try {
		const url = new URL(imageUrl);
		if (!url.hostname.endsWith(".r2.cloudflarestorage.com")) {
			return imageUrl;
		}

		const pathParts = url.pathname.split("/").filter(Boolean);
		const mediaIndex = pathParts.indexOf("media");
		if (mediaIndex === -1) return imageUrl;

		return workspaceImageUrlFromStorageKey(
			pathParts.slice(mediaIndex).map(decodeURIComponent).join("/"),
		);
	} catch {
		return imageUrl;
	}
}
